var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconHide = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0);}.b{fill:#8798ad;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-333 -344)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 32,
  height: 32,
  transform: "translate(333 344)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M8.707,24.707l16-16a1,1,0,0,0-1.414-1.414L21.481,9.1A13.984,13.984,0,0,0,16,8a14.522,14.522,0,0,0-9.659,3.747A17.588,17.588,0,0,0,3.954,14.3c-.266.349-.468.643-.6.852-.068.1-.121.189-.157.248l-.043.071-.012.021,0,.007v0h0a1,1,0,0,0,0,.993h0l0,0,.007.012.024.04c.02.033.048.079.085.138.073.116.18.28.32.481A17.192,17.192,0,0,0,8.646,21.94L7.293,23.293a1,1,0,0,0,1.414,1.414Zm1.4-4.231a14.678,14.678,0,0,1-3.8-3.065,14.772,14.772,0,0,1-1.1-1.381L5.19,16c.1-.14.215-.3.355-.488a15.584,15.584,0,0,1,2.113-2.26A12.524,12.524,0,0,1,16,10a12,12,0,0,1,3.934.652l-1.9,1.9a4,4,0,0,0-5.478,5.478Zm3.958-3.958,2.451-2.451a2,2,0,0,0-2.451,2.451Zm9.3-5.309a1,1,0,0,1,1.4-.191,17.458,17.458,0,0,1,3.057,3c.34.427.6.791.77,1.052.087.131.153.236.2.311l.054.089.023.039a1.05,1.05,0,0,1-.061,1.1c-.036.06-.089.144-.157.249-.137.209-.338.5-.6.852a17.582,17.582,0,0,1-2.387,2.553A14.522,14.522,0,0,1,16,24a14.13,14.13,0,0,1-3.013-.321,1,1,0,1,1,.425-1.954A12.129,12.129,0,0,0,16,22a12.524,12.524,0,0,0,8.342-3.253,15.58,15.58,0,0,0,2.113-2.26c.14-.184.258-.348.355-.488-.139-.2-.323-.453-.552-.74a15.459,15.459,0,0,0-2.7-2.649A1,1,0,0,1,23.364,11.209Z",
  transform: "translate(333 344)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHide, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-hide.b7d7ef77.svg";
export { ForwardRef as ReactComponent };